import moment from "moment";
import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentCompanyId, getCurrentUserId } from "@/utils";

/**
 * Tab 枚举
 */
export enum InvoiceTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

// 开票内容
export class InvoiceContent {
  receivedInvoiceCompanyId: string | undefined = undefined; // 收票单位ID
  title: string = ""; // 开票抬头
  taxNo: string = ""; // 税号
  openingBank: string = ""; // 开户银行
  openingAccount: string = ""; // 开户银行账号
  telephone: string = ""; // 开票电话
  provinceId: number = 0;
  cityId: number = 0;
  districtId: number = 0;
  address: string = ""; // 开票地址
}

// 开票明细
export class InvoiceDetail extends BaseReq {
  uuid: string = ""; // 唯一ID
  content: string = ""; // 开票内容
  model: string = ""; // 规格型号
  unit: string | undefined = undefined; // 单位
  count: number = 0 ; // 数量
  taxPrice: number = 0 ; // 单价-含税
  taxPriceTotal: number = 0; // 金额-含税
  taxRate: string = ""; // 税率
  price: number = 0; // 单价-不含税
  priceTotal: number = 0; // 金额-不含税
  tax: number = 0; // 税额
}

export class InvoiceReq extends BaseReq {
  contractId: string | undefined = undefined; // 合同ID
  contractName: string | undefined = undefined; // 合同ID
  projectId: string | undefined = undefined; // 项目ID
  applyDate: string = moment().format("YYYY-MM-DD"); // 开票日期
  amount: number = 0; // 本次开票金额
  invoiceType: string | undefined = undefined; // 开票类型
  taxRate: string | undefined = undefined; // 税率
  invoiceCompanyId: string = getCurrentCompanyId(); // 开票单位ID
  applyUserId: string = getCurrentUserId(); // 申请人ID
  remark: string = ""; // 摘要
  content: InvoiceContent = new InvoiceContent();
  details: InvoiceDetail[] = [];
  fileList: FileRecord[]; //附件
}

export class InvoicePageReq extends PaginationReq {
  invoiceBizNo: string | undefined = undefined; // 开票申请编号
  contractName: string | undefined = undefined; // 合同名称
  cooperationCompanyName: string | undefined = undefined; // 收票单位
  invoiceType: string | undefined = undefined; // 发票类型
  applyUserId: string | undefined = undefined; // 申请人ID
  invoiceStatus: string | undefined = undefined; // 开票状态
  applyProcessStatus: string | undefined = undefined; // 申请处理状态
  flowStatus: string | undefined = undefined; // 审批状态
  bizType: string | undefined = undefined; // 流程标识
  addRightBizType: string | undefined = undefined;
}

export class InvoiceListRecord extends UpdaterResp {
  id: string = ""; // 开票ID
  bizNo: string = ""; // 开票编号
  contractName: string = ""; // 开票合同名称
  projectName: string = ""; // 所属项目名称
  receivedInvoiceCompanyName: string = ""; // 收票单位名称
  invoiceTypeName: string = ""; // 发票类型
  amount: number = 0; // 申请开票金额
  taxRateValue: string = ""; // 税率
  applyUserName: string = ""; // 申请人名称
  invoiceStatusName: string = ""; // 开票状态
  applyProcessStatusName: string = ""; // 申请处理状态
  flowStatusName: string = ""; // 审批状态
  lastModifiedTime: string = ""; // 更新时间
}

export class InvoicePageResp extends PaginationResp<InvoiceListRecord> {}

class ApiContent extends InvoiceContent {
  receivedInvoiceCompanyName: string = "";
  provinceName: string = "";
  cityName: string = "";
  districtName: string = "";
}

class ApiDetail extends InvoiceDetail {}

export class InvoiceDetailResp extends UpdaterResp {
  contractId: string = ""; // 合同ID
  contractName: string = ""; // 合同名称
  projectId: string = ""; // 项目ID
  projectName: string = ""; // 项目名称
  applyDate: string = ""; // 开票日期
  amount: number = 0; // 本次开票金额
  invoiceType: string = ""; // 开票类型
  invoiceTypeName: string = ""; // 开票类型显示值
  taxRate: string = ""; // 税率
  taxRateValue: string = ""; // 税率显示值
  invoiceCompanyId: string = ""; // 开票单位ID
  invoiceCompanyName: string = ""; // 开票单位名称
  applyUserId: string = ""; // 申请人ID
  applyUserName: string = ""; // 申请人名称
  remark: string = ""; // 摘要
  flowStatus: string = ""; // 审批状态
  flowStatusName: string = ""; // 审批状态显示值
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态显示值
  applyProcessStatus: string = ""; // 申请处理状态
  applyProcessStatusName: string = ""; // 申请处理状态显示值
  apiContent: ApiContent = new ApiContent();
  apiDetails: ApiDetail[] = [];
}

export class ContractAmountReq extends BaseReq {
  contractId: string = ""; // 开票合同id
  invoiceApplicationId?: string = ""; // 开票申请单id
}

export class ContractAmountReqResp {
  applyInvoicedAmount: string = "";
  applyUninvoicedAmount: string = "";
  currentContractAmount: string = "";
  initialContractAmount: string = "";
  totalInvoicedAmount: string = "";
  uninvoicedAmount: string = "";
}
